module.exports = __webpack_public_path__ + "img/1@2x.c9a1d9d9.png";